const performanceRoutes = [
  {
    title: 'Overview',
    fullTitle: 'Email Performance',
    icon: 'insert_chart_outlined',
    titleIcon: true,
    path: '/performance/overview',
    permission: 'performance.overview.view',
    default: true,
  },
  {
    title: 'Template',
    fullTitle: 'Template Performance',
    icon: 'bar_chart',
    titleIcon: true,
    path: '/performance/templates/:templateId?/:templateName?',
    permission: 'performance.overview.view',
    hidden: true,
  },
  {
    title: 'CSV',
    fullTitle: 'CSV Performance',
    icon: 'subject',
    titleIcon: true,
    path: '/performance/csv',
    permission: 'performance.overview.view',
  },
  {
    title: 'Enoch Dashboard',
    fullTitle: 'Enoch Automation Metrics',
    icon: 'desktop_mac',
    titleIcon: true,
    path: '/performance/enoch',
    permission: 'performance.overview.view',
  },
  {
    title: 'History',
    fullTitle: 'Sending History',
    icon: 'history',
    titleIcon: true,
    path: '/performance/history',
    permission: 'mail.history.view',
  },
];

export default performanceRoutes;
